import { Controller } from '@hotwired/stimulus'

const TILE = 32 // px — matches .dashboard-sources__ico

export default class extends Controller {
  static targets = ['sources', 'chip']

  connect() {
    this.fit()

    if (typeof ResizeObserver !== 'undefined') {
      this.observer = new ResizeObserver(() => this.fit())
      this.observer.observe(this.element)
    }
  }

  disconnect() {
    this.observer?.disconnect()
  }

  fit() {
    if (!this.hasSourcesTarget || !this.hasChipTarget) return
    if (this.element.clientWidth === 0) return

    const sources = Array.from(this.sourcesTarget.children)
    const total = sources.length
    const base = parseInt(this.chipTarget.dataset.overflowBase || '0', 10) || 0

    sources.forEach(s => {
      s.style.display = ''
    })
    this.chipTarget.hidden = base <= 0
    this.chipTarget.textContent = `+${base}`

    const chipWidth = () =>
      Math.ceil(this.chipTarget.getBoundingClientRect().width)
    const fixedRight = Array.from(this.element.children)
      .filter(c => c !== this.sourcesTarget && c !== this.chipTarget)
      .reduce((sum, c) => sum + c.getBoundingClientRect().width, 0)
    const available = Math.floor(this.element.clientWidth - fixedRight)

    if (total * TILE + (base > 0 ? chipWidth() : 0) <= available) return

    this.chipTarget.hidden = false
    this.chipTarget.textContent = `+${total + base}`
    const room = Math.max(0, Math.floor((available - chipWidth()) / TILE))
    sources.forEach((s, i) => {
      if (i >= room) s.style.display = 'none'
    })
    this.chipTarget.textContent = `+${total - room + base}`
  }
}
